<template>
	<nav id="nav" class="shadow-1">
		<!-- <router-link to="/" exact><img id="logo" alt="logo" src="../assets/img/svg/24px/logo_24px.svg" /></router-link> -->
		<router-link to="/" exact><img id="logo" alt="logo" src="../assets/img/svg/xxx/logo_blue_light.svg" /></router-link>
		<h1 id="heading">{{page_name}}</h1>
		<img id="menu-icon" class="shadow-sm border-radius-1 " 
			alt="menu" src="../assets/img/svg/24px/menu_24px.svg"
			@click="show_menu = !show_menu"/>
		<ul id="links" v-if="show_menu" >
			<li>
				<router-link class="shadow-3" to="/" exact>home</router-link>
			</li>
			<li>
				<router-link class="shadow-3" to="/projects" exact>projects</router-link>
			</li>
			<li>
				<router-link class="shadow-3" to="/directors" exact>directors</router-link>
			</li>
			<li>
				<router-link class="shadow-3" to="/contact" exact>contact us</router-link>
			</li>
		</ul>
	</nav>
</template>

<script>
import emitter from '@/emitter';
export default {
	name: 'Nav',
	data() {
		return {
			show_menu: true,
			page_name: '',
			nav_element: null
		};
	},
	created() {
		this.checkToDisplayMenu(this);
		// THEN HIDE THE MENU ON INITIAL LOAD IF ON A SMALLER SCREEN
		if(Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768) {
			this.show_menu = false;
		}
		emitter.$on('new-page-name', (_name) => {
			if(_name !== undefined) {
				this.page_name = _name;
			} else {
				// console.error('empty page name');
			}
		});
		emitter.$on('hide-menu', () => {
			this.show_menu = false;
		});
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.checkToDisplayMenu(this);
		});
		this.nav_element = document.querySelector('#nav');
	},
	methods: {
		checkToDisplayMenu: (_this) => {
			const viewport_width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
			if (viewport_width > 767) {
				_this.show_menu = true;
			}
		}
	},
	watch: {
		show_menu(to) {
			if(to) {
				setTimeout(() => {
					const bounding_rect_link = document.querySelector('#links').getBoundingClientRect();
					document.querySelector('#app').scrollBy({
						left: 0, 
						top: bounding_rect_link.height,
						behavior: 'smooth'
					});
				}, 500);
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	@import '../assets/style/main.scss';


	$link-border-radius: 0.3em;


	
	/* DO NOT INCLUDE transform-style: inherit;, IT MAKES THE ITEM JUMP IN FIREFOX */
	#nav {
		>* {
			float: left;
			&:nth-child(2) {
				margin-left: 1em;
			}
			&:nth-child(3) {
				margin-left: 1em;
			}
			&:nth-child(4) {
				margin-top: 2em;
				float: right;
			}
			padding-top: 1em;
			@supports (position: sticky) {
				float: unset;
				&:nth-child(2) {
					margin-left: unset;
				}
				&:nth-child(3) {
					margin-left: unset;
				}
				&:nth-child(4) {
					margin-top: unset;
					float: unset;
				}
				padding-top: unset;
			}
		} 

		position: fixed !important;
		top: 0px !important;
		width:  100vw !important;
		@supports (position: sticky) {
			position: sticky !important;
			top: -1px !important;
		}
		transform-style: none;
		padding: 0em;
		background-color: $white;
		z-index: 1000;
		
		
		display: grid;
		grid-template-columns: min-content auto;
		grid-template-rows: auto;
		align-items: center;
		


		ul {
			height: 100%;
			grid-area: links;
			list-style-type: none;
			padding: 0px;
			margin: 0px;
			li {
				a {
					$bg-colour-active-link: $red;
					$bg-colour-inactive-link: $blue;
					$bg-colour-hover: $red;

					@mixin active() {
						background-color: 	$bg-colour-active-link;
						color: hsl(207, 81%, 8%);
					}
					@mixin inactive {
						background-color: 	$bg-colour-inactive-link;
						color: hsl(42, 29%, 93%);
					}
					@mixin half-on {
						background-color: 	$bg-colour-hover;
						color: hsl(42, 29%, 93%);
					}

					padding: 0.2em 1em;
					text-decoration: none;
					color: hsl(42, 29%, 93%);
					background-color: $bg-colour-inactive-link;
					backdrop-filter: blur(10px);

					&.router-link-exact-active {
						@include active();
						animation: turn-on 600ms 1;
					}

					// DO THE ANIMATION ON HOVER ONLY IF THE LINK IS NOT ACTIVE
					&:hover:not(.router-link-exact-active) {
						animation: pulse 1s infinite;
					}

					@keyframes turn-on {
						0% {
							@include inactive();
						}
						12.5% {
							@include active();
						}
						25% {
							@include inactive();
						}
						50% {
							@include active();
						}
						50% {
							@include inactive();
						}
						67.5% {
							@include active();
						}
						75% {
							@include inactive();
						}
						100% {
							@include active();
						}
					}

					@keyframes pulse {
						0% {
							@include inactive();
						}
						50% {
							@include half-on();
						}
						100% {
							@include inactive();
						}
					}
				}
			}
		}
	}
	#heading {
		grid-area: heading;
		margin: 0px;
		color: #415672;
		font-size: 1.5em;
        font-weight: 300;
	}
	#logo {
		grid-area: logo;
		height: 48px;
		@media (max-width: 767px) {
			height: 40px;
		}
		min-width: 48px;
		padding-top: 0.2em;
		margin: 0.4em 0em;
	}
	#menu-icon {
		grid-area: menu-icon;
		width: 2.5em;
		height: 2.5em;
		margin-left: auto;
		&:hover {
			cursor: pointer;
		}
	}
	@media (max-width: 767px) {
		#menu-icon {
			display: inline-block;
		}
		#nav {
			grid-template-areas: "logo heading menu-icon" "links links links";
			justify-content: space-between;
			padding: 0em 0.5em;
			ul {
				position: absolute;
				left: -0.5em;
				top: -0.65em;
				width: 100vw;
				padding: 0.5em;
				margin-left: 0px;
				border-bottom-left-radius: 0.5em;
				border-bottom-right-radius: 0.5em;
				li {
					a {
						background-color: $white;
						background-image: linear-gradient($white, rgb(212, 224, 233));
						color: $blue-dark;
						font-size: 1.2em;
						margin-top: 0.0em;
						padding-top: 0.5em;
						padding-bottom: 0.5em;
						&:hover {
							color: $blue !important;
							background-image: linear-gradient($white, rgba(212, 224, 233, 0.3));
						}
						&.router-link-exact-active {
							background-image: linear-gradient($white, rgba(212, 224, 233, 0.3));
						}
					}
					&:first-of-type {
						a {
							margin-top: 0px;
							border-top-left-radius: $link-border-radius;
							border-top-right-radius: $link-border-radius;
						}
					}
					&:last-of-type {
						a {
							border-bottom-left-radius: $link-border-radius;
							border-bottom-right-radius: $link-border-radius;
						}
					}
				}

				li a {
					display: block;
					width: 100%;
				}
			}
		}
	}
	@media (min-width: 768px) {
		#menu-icon {
			display: none;
		}
		#nav {
			grid-template-areas: "logo heading links";
			justify-items: end;
			padding: 0em 0em 0em 0.5em;
			ul {
				display: flex;
				align-items: stretch;
				li {
					display: inline-block;
					&:last-of-type {
						a {
							margin-right: 0px;
						}
					}
					a {
						font-size: 16px;
						letter-spacing: 0.1px;
						display: inline-flex;
						align-items: center;
						padding: 0em 3vw;
						height: 100% !important;
					}
				}
			}
		}
	}
</style>
